import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';

import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { spinnerInterceptor } from '@utilities/components/spinner/interceptors/spinner.interceptor';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../environments/environment';
import { oktaInterceptor } from './core/interceptors/okta.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { combinedInterceptor } from './core/interceptors/combined.interceptor';
import { AppInsightsInterceptor } from './core/interceptors/app-insights.interceptor';
import { ApplicationInsightsService } from './core/services/applicationInsights.service';

registerLocaleData(localeEsMx);

const oktaAuth = new OktaAuth({
  issuer: environment.oktaConfig.issuer,
  clientId: environment.oktaConfig.clientId,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'offline_access'],
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withViewTransitions({ skipInitialTransition: true }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    importProvidersFrom(OktaAuthModule.forRoot({ oktaAuth })),
    provideHttpClient(
      withFetch(),
      withInterceptors([combinedInterceptor, spinnerInterceptor]),
      withInterceptorsFromDi()
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (appInsights: ApplicationInsightsService) => () => appInsights.initialize(),
      deps: [ApplicationInsightsService],
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es-MX' },
    provideAnimationsAsync(),
  ],
};
